import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ResponseCubeRestructureCheck } from 'types/api/SystemTenant/AROCube/CubeRestructureTypes';

export function CubeRestructureImpact({
  data,
  preview = true,
}: {
  data: ResponseCubeRestructureCheck;
  preview?: boolean;
}) {
  const blockers = data.blockers.length
    ? data.blockers
    : !data.timePeriods.compatible
    ? ['The time period intervals are incompatible.']
    : [];

  return (
    <Stack spacing={1.5} aria-live='polite'>
      <Typography variant='body2' fontWeight='bold'>
        {preview ? 'Data impact' : 'Reviewed data impact'} {data.tenantName}
      </Typography>
      {((preview && !data.canRestructure) || blockers.length > 0) && (
        <Alert severity='error'>
          <AlertTitle sx={{ fontWeight: 600 }}>Unable to restructure this cube</AlertTitle>
          {blockers.length > 1 ? (
            <Stack component='ul' spacing={0.5} sx={{ m: 0, pl: 2.5 }}>
              {blockers.map((blocker, index) => (
                <Typography component='li' variant='body2' key={index}>
                  {blocker}
                </Typography>
              ))}
            </Stack>
          ) : (
            <Typography variant='body2'>
              {blockers[0] || 'Review the selected options and check the data mapping again.'}
            </Typography>
          )}
        </Alert>
      )}
      <Stack spacing={0.5}>
        <Typography variant='body2'>
          KTree (M): {data.member.matchingBaseMembers} matching base members; {data.member.unmatchedSourceBaseMembers}{' '}
          unmatched.
        </Typography>
        <Typography variant='body2'>
          Time periods: {data.timePeriods.matchingPeriodCount} matching ({data.timePeriods.sourceInterval}).{' '}
          {data.timePeriods.matchingPastYears} past years,{' '}
          {data.timePeriods.currentYearMatching ? 'current year matches' : 'current year does not match'},{' '}
          {data.timePeriods.matchingFutureYears} future years.
        </Typography>
      </Stack>
      {data.warnings.length > 0 && (
        <Alert severity='warning' aria-labelledby='restructure-warnings-title'>
          <AlertTitle id='restructure-warnings-title' sx={{ fontWeight: 600 }}>
            {preview ? 'Review before restructuring' : 'Restructuring warnings'}
          </AlertTitle>
          {data.warnings.length > 1 ? (
            <Stack component='ul' spacing={0.5} sx={{ m: 0, pl: 2.5 }}>
              {data.warnings.map((warning, index) => (
                <Typography component='li' variant='body2' key={index}>
                  {warning}
                </Typography>
              ))}
            </Stack>
          ) : (
            <Typography variant='body2'>{data.warnings[0]}</Typography>
          )}
        </Alert>
      )}
    </Stack>
  );
}
